export const OrderCI_VIRTUALYOUR_STATE_PATH = 'virtualTour';

export class VirtualTourModel {
	data?: any;
	totalCount?: number;
	offset?: number;
	limit?: number;

	constructor() {
		this.data = [];
		this.totalCount = undefined;
		this.offset = undefined;
		this.limit = undefined;
	}
}
